import { kistenText } from './kisten';
import { MinusCircleIcon } from '../admin/NavIcons';

interface Props {
  active: boolean;
  /** Current stepper magnitude, so the hint states exactly what will book. */
  quantity: number;
  /**
   * Die scharfe Kistenzahl, falls in Kisten gebucht wird (nur an einer Entnahme).
   *
   * 2026-09-27: Ohne sie log der Hinweis. Er nannte die Stückzahl des Steppers — „Nächste
   * Buchung: -1" —, während in Wahrheit eine ganze Kiste zurückgebucht worden wäre. Der Stepper
   * selbst zeigt in diesem Zustand längst einen Strich statt einer Zahl; ausgerechnet der
   * Hinweis, der sagen soll, was gleich passiert, nannte die Zahl trotzdem weiter.
   */
  crates?: number;
  onToggle: () => void;
}

/**
 * v0.12 FR-205/D-2: switches the next booking between a normal (positive)
 * quantity and a correction (negative) one. Deliberately its own small
 * control, not folded into QuantityStepper -- that widget stays a plain
 * 1..20 magnitude control; this is what decides the SIGN applied to it. Per
 * D-2 the toggle must be prominent enough to notice before tapping a
 * beverage tile, but small enough not to dominate the screen or slow the
 * ordinary positive-quantity happy path (NFR-1).
 */
export default function CorrectionToggle({ active, quantity, crates, onToggle }: Props) {
  const naechste = crates === undefined ? `-${quantity}` : `−${kistenText(crates)}`;
  return (
    <div className="kiosk-correction-row">
      {/* 2026-10-08 (Owner, Vorschlag 10): ein Minus im Kreis statt „↩". Dasselbe Zeichen trug
          auch „Anderes Mitglied" -- zwei völlig verschiedene Handlungen, ein Bild. Das Minus sagt,
          was die nächste Buchung tut: Sie zieht ab. Das Wort bleibt, am Kiosk bedienen Helfer. */}
      <button
        type="button"
        aria-pressed={active}
        className="kiosk-correction-toggle bt-icon-text"
        onClick={onToggle}
      >
        <MinusCircleIcon />
        {active ? 'Korrektur AN' : 'Korrektur'}
      </button>
      {active && (
        <span className="kiosk-correction-hint" role="status">
          Nächste Buchung: {naechste}
        </span>
      )}
    </div>
  );
}
